var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.innerSrc},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }